module.exports = __webpack_public_path__ + "media/audio60.bcf98944.mp3";